import dragRaceChatScreenshot from "~/images/share/drag-race-chat-screenshot"
import { cn } from "~/common/cn"

interface DragRaceChatScreenshotProps {
  className?: string
}

export const DragRaceChatScreenshot = ({ className }: DragRaceChatScreenshotProps) => (
  <div className={cn("flex justify-center px-4 py-2", className)}>
    <img
      src={dragRaceChatScreenshot.src}
      width={dragRaceChatScreenshot.width}
      height={dragRaceChatScreenshot.height}
      alt="Chat conversation preview"
      className="w-full max-w-[360px] rounded-2xl"
    />
  </div>
)
